export function createShareBtn() {
   // Use querySelectorAll and a standard guard clause
   const btns = document.querySelectorAll('.shareBtn');
   if (btns.length === 0) return;

   btns.forEach(btn => {
      btn.addEventListener('click', clickHandler);
   });
}

async function clickHandler() {
   const isDesktop = !matchMedia('(pointer: coarse)').matches;
   const notice = this.previousElementSibling;
   const shareUrl = this.getAttribute('data-share-url');
   const shareTitle = this.getAttribute('data-share-title');

   const shareData = {
      title: shareTitle,
      url: shareUrl
   };

   if (isDesktop || !navigator.share) {
      copyToClipboard(notice, shareUrl);
      return;
   }

   try {
      await navigator.share(shareData);
      console.log('Share supported');
   }

   catch (err) {
      if (err.name !== 'AbortError') {
         copyToClipboard(notice, shareUrl);
         console.log('Share drawer is not supported or failed');
      }
   }
}

/*----------------------------*/

function copyToClipboard(notice, shareUrl) {
   const copyText = shareUrl;

   if (!navigator.clipboard) {
      fallbackCopyToClipboard(notice, copyText);
   }
   else {
      navigator.clipboard.writeText(copyText).then(function() {
         showNotice(notice);
         console.log('Navigator: Copying to clipboard was successful!');
      }, function(err) {
         console.error('Navigator: Could not copy text: ', err);
      });
   }
}

/*----------------------------*/

function fallbackCopyToClipboard(notice, text) {
   const textArea = document.createElement('textarea');
   textArea.value = text;
   
   textArea.style.top = "0";
   textArea.style.left = "0";
   textArea.style.position = "fixed";
 
   document.body.appendChild(textArea);
   textArea.focus();
   textArea.select();
 
   try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      showNotice(notice);
      console.log('Fallback: Copying text command was ' + msg);
   } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
   }
 
   document.body.removeChild(textArea);
}

/*----------------------------*/

function showNotice(notice) {
   if (!notice) return;
   
   notice.style.opacity = '1';
   notice.setAttribute('aria-hidden', 'false');

   setTimeout(() => {
      notice.style.opacity = '';
      notice.setAttribute('aria-hidden', 'true');
   }, 2000);
}

document.addEventListener('DOMContentLoaded', () => {
   createShareBtn();
});